import React from "react";
import { TextField } from "@material-ui/core";

export const FilterField = ({ label, value, setFiler }) => {
  return (
    <TextField
      style={{ margin: "5px" }}
      margin="dense"
      label={label}
      fullWidth
      variant="outlined"
      value={value}
      onChange={(event) => {
        setFiler(event.target.value);
      }} />
  );
};
